import { UntypedFormGroup } from '@angular/forms';

/*
 * Custom validator to check 2 AbstractControl values
 */

export const passwordMatchingValidator = (controlName: string, matchingControlName: string) => (formGroup: UntypedFormGroup) => {
  const control = formGroup.controls[controlName];
  const matchingControl = formGroup.controls[matchingControlName];

  if (matchingControl.errors && !matchingControl.errors.mustMatch) {
    return;
  }

  if (control.value !== matchingControl.value) {
    matchingControl.setErrors({ mustMatch: true });
  } else {
    matchingControl.setErrors(null);
  }
};
